<template>
  <div class="editable-label">
    <template v-if="!isEditing">
      <div class="default-label">
        <div class="default-label-left">
          <div>
            <FeatherIcon :icon="icon" size="18" class="mr-1" />
          </div>
          <b-table
            v-if="defaultData && typeof defaultData == 'object'"
            hover
            thead-class="hidden"
            :items="
              () => {
                const items = [];
                for (const field in defaultData) {
                  items.push({ field, value: defaultData[field] });
                }
                return items;
              }
            "
          >
          </b-table>
          <span v-else>
            {{ defaultData || this.$t("ticket.no_information") }}
          </span>
        </div>

        <div v-if="editable" class="default-label-right">
          <FeatherIcon
            v-b-tooltip.hover
            icon="Edit2Icon"
            size="18"
            class="clickable-icon"
            :title="$t('ticket.edit')"
            @click="
              isEditing = true;
              inputData = defaultData;
            "
          />
        </div>
      </div>
    </template>
    <template v-else>
      <BForm class="edit-label" @submit.prevent="handleEdit">
        <div class="edit-label-left" style="position: relative">
          <FeatherIcon :icon="icon" size="18" class="mr-1 clickable-icon" />
          <template v-if="!loading">
            <div
              style="width: 100%"
              :class="{ error: v$.inputData.$errors.length }"
            >
              <b-form-input
                ref="inputRef"
                v-model.trim="inputData"
                class="input-edit-form"
                :placeholder="placeholder"
                size="md"
                autocomplete="off"
                @keydown.esc="isEditing = false"
                @input="v$.inputData.$touch()"
                @blur="v$.inputData.$touch()"
              />
              <FeatherIcon
                v-b-tooltip.hover
                :title="$t('ticket.cancel')"
                icon="XIcon"
                size="18"
                class="clickable-icon input-edit-icon-cancel"
                @click="
                  isEditing = false;
                  inputData = '';
                "
              />
              <label :for="`submit-button-${typeData}`">
                <FeatherIcon
                  v-b-tooltip.hover
                  :title="$t('ticket.save')"
                  icon="CheckIcon"
                  size="18"
                  class="clickable-icon input-edit-icon-save"
                />
              </label>
              <b-button
                :id="`submit-button-${typeData}`"
                style="display: none"
                type="submit"
              />

              <span v-for="error of v$.inputData.$errors" :key="error.$uid">
                <span style="color: #8d5185">
                  {{ error.$message }}
                </span>
              </span>
            </div>
          </template>
          <template v-else> {{ $t('general.loading') }} </template>
        </div>
        <div class="edit-label-right"></div>
      </BForm>
    </template>
  </div>
</template>

<script>
import { BTooltip, BFormInput, BForm, BButton, BTable } from "bootstrap-vue";
import CustomerRepository from "@/repositories/Api/CustomerRepository";
import Toast from "@/libs/toast";

import { useVuelidate } from "@vuelidate/core";
import { required, email, numeric, maxLength } from "@vuelidate/validators";

import {
  requiredValidate,
  maxValidate,
  emailValidate,
  numericValidate,
} from "@/libs/i18n/i18n-validator";

function handleValidate(type) {
  switch (type) {
    case "email":
      return {
        requiredValidate,
        emailValidate,
        maxLength: maxValidate(30),
      };
    case "number":
      return {
        requiredValidate,
        numericValidate,
        maxLength: maxValidate(15),
      };
    default:
      return {
        requiredValidate,
        maxLength: maxValidate(30),
      };
  }
}
export default {
  name: "EditableLabel",
  components: {
    BTooltip,
    BFormInput,
    BForm,
    BButton,
    BTable,
  },
  props: {
    icon: {
      type: String,
      required: "UserIcon",
    },
    placeholder: {
      type: String,
      default: "Enter",
    },
    defaultData: {
      type: [String, Number, Object],
      default: "Loading",
    },
    editable: {
      type: Boolean,
      default: false,
    },
    metaData: {
      type: String,
      default: "id",
    },
    validateData: {
      type: String,
      default: "text",
    },
    typeData: {
      type: String,
      default: "text",
    },
    store: {
      type: Object,
      default: null,
    },
  },
  // setup(props) {
  //   const ticketStore = useTicketStore()
  //   const isEditing = computed(() => {
  //     if (props.typeData === 'number') {
  //       return ticketStore.editableStatue.isEditablePhone
  //     }
  //     if (props.typeData === 'email') {
  //       return ticketStore.editableStatue.isEditableEmail
  //     }
  //     if (props.typeData === 'text') {
  //       return ticketStore.editableStatue.isEditableName
  //     }
  //     return false
  //   })
  //
  //   return {
  //     isEditing,
  //   }
  // },

  data() {
    return {
      loading: false,
      isEditing: false,
      inputData: "",
    };
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      inputData: handleValidate(this.validateData),
      // inputData: props.validateData === "text" return
    };
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        this.isEditing = false;
      }
    },
  },
  methods: {
    makeSuccessToast(append = false) {
      Toast.fire({
        icon: "success",
        title: this.$t("ticket.update_ticket_successfully_message"),
      });
    },
    makeExistingToast(append = false) {
      Toast.fire({
        icon: "error",
        title: this.$t("ticket.update_ticket_existing_message"),
      });
    },
    makeFailToast(append = false) {
      Toast.fire({
        icon: "error",
        title: this.$t("ticket.update_ticket_failed_message"),
      });
    },
    // makeSuccessToast(append = false) {
    //   this.$bvToast.toast(this.$t('ticket.update_ticket_successfully_message'), {
    //     title: this.$t('ticket.update_ticket_successfully'),
    //     autoHideDelay: 4000,
    //     appendToast: append,
    //     variant: 'success',
    //   })
    // },
    // makeExistingToast(append = false) {
    //   this.$bvToast.toast(this.$t('ticket.update_ticket_existing_message'), {
    //     title: this.$t('ticket.update_ticket_existing'),
    //     autoHideDelay: 4000,
    //     appendToast: append,
    //     variant: 'danger',
    //   })
    // },
    // makeFailToast(append = false) {
    //   this.$bvToast.toast(this.$t('ticket.update_ticket_failed_message'), {
    //     title: this.$t('ticket.update_ticket_failed'),
    //     autoHideDelay: 4000,
    //     appendToast: append,
    //     variant: 'danger',
    //   })
    // },
    handleEdit() {
      console.log("handleEdit");
      this.loading = true;
      CustomerRepository.updateCustomerProfile(this.metaData, {
        [this.typeData]: this.inputData,
      })
        .then((res) => {
          const { data } = res.data;
          console.log(data);
          this.store.updateVisitorProfileOnTicketList(data);
          this.defaultData = this.inputData;
          this.isEditing = false;
          this.loading = false;
          this.makeSuccessToast(true);
        })
        .catch((err) => {
          this.loading = false;
          this.makeFailToast(true);

          console.log(err);
        });
    },
    handleCloseEdit() {
      this.isEditing = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.labelName {
  margin-bottom: unset;
  //font-weight: bold;
}

.editable-label {
  .default-label {
    display: flex;
    justify-content: space-between;

    .default-label-left {
      display: flex;
    }

    .default-label-right {
    }
  }

  .edit-label {
    display: flex;
    justify-content: space-between;

    .edit-label-left {
      display: flex;
      flex: 1;
    }

    .edit-label-right {
      display: flex;
      gap: 1em;
    }
  }
}

.input-edit-form {
  padding-right: 5em;
}

.input-edit-icon {
  position: absolute;
  top: 0.75em;
}

.input-edit-icon-save {
  @extend .input-edit-icon;
  right: 0.5em;
}

.input-edit-icon-cancel {
  @extend .input-edit-icon;
  right: 2.5em;
}

.clickable-icon {
  cursor: pointer;
}

.header-subtitle {
  font-size: 0.85em;
  color: gray;
}

.label-container {
  display: flex;
  gap: 1em;
}

.container-right_sidebar {
  padding: 1.5rem;
}
</style>
